import { configureStore } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';
import masterDataSlice from '../slice/masterDataSlice';
import examEditSlice from '../slice/examEditSlice';
import appConfigSlice from '../slice/appConfigSlice';
import examTemplateEditSlice from '../slice/examTemplateEditSlice';
import editQuestionModalSlice from '../slice/editQuestionModalSlice';

enableMapSet();

const store = configureStore({
  reducer: {
    masterData: masterDataSlice.reducer,
    examEdit: examEditSlice.reducer,
    examTemplateEdit: examTemplateEditSlice.reducer,
    editQuestionModal: editQuestionModalSlice.reducer,
    appConfig: appConfigSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
